let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5nM89")).then(() => parcelRequire('j1jR0'));